$(function(){
  $(".featured-slider").slick({
    slidesToShow: 2,
    slidesToScroll: 1,
    infinite: true,
    dots: true,
    arrows: true,
    responsive: [{

      breakpoint: 1025,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      }

    }, {

      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      }

    }]
  });
  $(".related-products .grid--gallery").slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    infinite: true,
    dots: true,
    arrows: true,
    responsive: [{

      breakpoint: 1025,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 4,
      }

    }, {

      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      }

    }]
  });
  console.log("Ready123");
});

var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}